import * as React from 'react'
import * as TogglePrimitive from '@radix-ui/react-toggle'
import { tv, VariantProps } from 'tailwind-variants'

import { cn } from '@/lib/utils'

const toggleVariants = tv({
	base: 'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors hover:bg-green-20 focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-green data-[state=on]:text-neutral [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
	variants: {
		variant: {
			default: 'bg-green-10 text-neutral-100'
		},
		size: {
			default: 'h-9 px-2 min-w-9',
			full: 'w-full px-2.5 h-10'
		}
	},
	defaultVariants: {
		variant: 'default',
		size: 'default'
	}
})

const Toggle = React.forwardRef<
	React.ElementRef<typeof TogglePrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
	<TogglePrimitive.Root ref={ref} className={cn(toggleVariants({ variant, size, className }))} {...props} />
))

Toggle.displayName = TogglePrimitive.Root.displayName

export { Toggle, toggleVariants }
